// extracted by mini-css-extract-plugin
export var bigListStyle = "shop-cart-summary-price-module--big-list-style--5b88d";
export var bold = "shop-cart-summary-price-module--bold--0b6bc";
export var countHolder = "shop-cart-summary-price-module--count-holder--cdf27";
export var countLine = "shop-cart-summary-price-module--count-line--154c2";
export var pink = "shop-cart-summary-price-module--pink--defcf";